import {
  API_ENDPOINTS,
  get,
  handleApiError,
  handleResponse,
  post,
  Response,
} from '@/api/api.ts';
import { OS_TYPE } from '@/utils/agent.ts';
import { AxiosResponse } from 'axios';
import {
  Terms,
  TermsCategory,
  TermsContentsResponse,
  TermsResponse,
  ServiceCode,
  V2TermsResponse,
} from '@/api/terms.types.ts';

export const fetchTerms = async (): Promise<TermsResponse> => {
  try {
    const res: AxiosResponse<Response<TermsResponse>> = await get({
      url: API_ENDPOINTS.terms,
      params: { os: OS_TYPE },
    });
    return handleResponse(res);
  } catch (e) {
    return handleApiError(e);
  }
};

export const fetchTermsContents = async (
  category: TermsCategory,
): Promise<TermsContentsResponse> => {
  try {
    const res: AxiosResponse<Response<TermsContentsResponse>> = await get({
      url: API_ENDPOINTS.terms,
      params: { os: OS_TYPE, category },
    });
    return handleResponse(res);
  } catch (e) {
    return handleApiError(e);
  }
};

export const changeTermsAgreement = async (
  newTermsList: Terms[],
): Promise<void> => {
  try {
    const res: AxiosResponse<Response> = await post({
      url: API_ENDPOINTS.terms,
      params: { os: OS_TYPE },
      data: { terms: newTermsList },
    });
    return handleResponse(res);
  } catch (e) {
    return handleApiError(e);
  }
};

export const fetchV2Terms = async (
  serviceCode: ServiceCode,
): Promise<V2TermsResponse> => {
  try {
    const res: AxiosResponse<Response<V2TermsResponse>> = await get({
      url: API_ENDPOINTS.v2Terms,
      params: { os: OS_TYPE, serviceCode },
    });
    return handleResponse(res);
  } catch (e) {
    return handleApiError(e);
  }
};
